import numeral from 'numeral';

// Constellation
import { Spacer, Text, Trigger } from '@zillow/constellation';

// Components
import ChangePriceModal from '../ChangePriceModal';

// Flux
import { useAppSelector } from '../flux/configureStore';

// Utils/misc
import * as S from './styles';
import type AddressModelType from '../models/Address';

const RENT_ZESTIMATE = (
  <>
    Rent Zestimate<S.SupStyles>®</S.SupStyles>
  </>
);

const ZestimateSummary = () => {
  const userProperty: AddressModelType = useAppSelector((state) => state.address);
  const priceFromFilter = useAppSelector((state) => state.filter.price);

  const { rentZestimate } = userProperty;

  let useRentZestimate: boolean;

  if (rentZestimate && !priceFromFilter) {
    useRentZestimate = true;
  } else if (rentZestimate && priceFromFilter && rentZestimate === priceFromFilter) {
    useRentZestimate = true;
  } else if (priceFromFilter) {
    useRentZestimate = false;
  } else {
    useRentZestimate = false;
  }

  const changePriceModal = (props: any, close: () => void) => <ChangePriceModal {...props} close={close} />;

  const priceBasis = useRentZestimate ? RENT_ZESTIMATE : 'custom price';

  return (
    <Spacer marginBottom="sm">
      <Text as="h6">
        Based on your {priceBasis} of ${numeral(priceFromFilter || rentZestimate).format('0,0')}{' '}
        {/* @ts-ignore triggered={changePriceModal} */}
        <Trigger triggered={changePriceModal}>
          <S.AdjustPriceButton>Adjust rental price</S.AdjustPriceButton>
        </Trigger>
      </Text>
    </Spacer>
  );
};

export default ZestimateSummary;
